import { render } from "./DashboardNav.vue?vue&type=template&id=f43508aa&scoped=true"
const script = {}

import "./DashboardNav.vue?vue&type=style&index=0&id=f43508aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f43508aa"

export default script